(function () {
    'use strict';

    let module = angular.module('imApp');

    module.component('userGroups', {
        templateUrl: 'views/components/views/userGroups/userGroups.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['stateService', 'userGroupsService', function (stateService, userGroupsService) {

            // #region VARIABLES & DEFINITIONS

            let vm = this;

            vm.model = {
                itemsListUserGroups: []
            };

		    // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE FUNCTION CALLS

            let loadUserGroups = function () {
                userGroupsService.listUserGroups().then(function (result) {
                    angular.copy(result, vm.model.itemsListUserGroups);
                });
            };

		    // #endregion LOAD PROCEDURE FUNCTION CALLS
            
            // #region MULTI DIRECTION BUTTON FUNCTIONS

            vm.goToFunc = function (state, e) {
                let go = function (parms) {
                    if (e?.ctrlKey) {
                        stateService.newTab(state, parms);
                    } else {
                        stateService.go(state, parms);
                    }
                };

                switch (state) {
                    case 'usergroupedit':
                        go({ usergroup_keyno: '0' });
                        break;
                    default:
                        break;
                }
            };

            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                loadUserGroups();
            };

            // #endregion ON INIT FUNCTION

        }]
    });
})();
